import { useCallback } from 'react';

import type { ChatMessage } from '@karehero/models';

import { useFeatureFlag } from './useFeatureFlags';
import { saidKeys, useFeltOnNew } from './useFeltOnNew';
import { type HapticStrength, useHaptics } from './useHaptics';
import { ONBOARDING_HAPTICS_FLAG } from './useOnboardingHaptics';

// Heavier than onboarding's, whose light tap is too easy to miss.
const SAID_STRENGTH: HapticStrength = 'heavy';

export interface UseServerChatHapticsOptions {
  messages: readonly ChatMessage[];
  /** Whether the session has loaded, so what is already there is not felt. */
  isReady: boolean;
}

/** useServerChatHaptics taps as the server's agent says something. */
export const useServerChatHaptics = ({
  messages,
  isReady,
}: UseServerChatHapticsOptions) => {
  // Felt by the same members as onboarding's taps, under its flag.
  const isEnabled = !!useFeatureFlag(ONBOARDING_HAPTICS_FLAG);
  const { impact } = useHaptics({ isEnabled });
  const feelSaid = useCallback(() => impact(SAID_STRENGTH), [impact]);

  useFeltOnNew(saidKeys(messages), { isReady, isSettled: true }, feelSaid);
};
